import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const carrierCodeApiSchema = v.object({
  carrierCodeId: v.string(),
  carrierKey: v.number(),
  codeDesc: v.string(),
  codeType: v.string(),
  id: v.number(),
});

export const carrierCodeSchema = v.object({
  ...carrierCodeApiSchema.entries,
  ...optionSchema.entries,
});

export const carrierCodesApiSchema = paginatedSchema(carrierCodeApiSchema);

export type CarrierCodeApi = v.InferOutput<typeof carrierCodeApiSchema>;
export type CarrierCodesApi = v.InferOutput<typeof carrierCodesApiSchema>;

export type CarrierCodeFilters = Filters<CarrierCodeApi>;

export type CarrierCodeFiltersUpdateApi = FiltersUpdateApi<CarrierCodeApi>;

export type CarrierCode = Prettify<Option<v.InferOutput<typeof carrierCodeSchema>>>;

export type CarrierCodes = Entities<CarrierCode>;
